enum AlertType {

    Price = 1,
    Change = 2,
}
export default AlertType;
